export default {
  cardPack: '卡包',
  cardsSuffix: '张卡包',
  cardPower: '卡包能力',
  cardPowerValue: '{0}点卡包能力',
  cardPowerDescription: '所有激活卡包的能力会累加，并提升该功能的基础属性',
  notFound: '未找到卡包',
  fullCollectionReward: '集齐奖励',
  canFind: '此卡包可在以下卡包中获得',
  cannotFind: '在当前可用的卡包中无法获得此卡包',
  active: '已激活卡包',
  equipped: '已装备卡包',
  onActive: '激活时',
  onDuplicate: '重复获得时',
  activeDescription: '可以装备重复卡包，并在下次声望时消耗这些卡包以激活其效果。这些效果将持续有效，直到您再次进行声望重置。',
  equipTutorial: {
    description: '您收集到了第一张卡包！大多数卡包在激活时会产生效果，要启用它，您需要：',
    1: '收集一张卡包的副本',
    2: '解锁主要功能之一的声望',
    3: '进入声望菜单并装备重复卡包（必须与卡包右下角显示的功能相同）',
    4: '装备卡包后进行声望重置',
    5: '卡包将被消耗，其效果将持续有效，直到您再次进行声望重置'
  },
  card: {
    'MI-0001': '基础装备',
    'MI-0002': '未使用的镐子',
    'MI-0003': '镐子箱',
    'MI-0004': '点燃导火索！',
    'MI-0005': '深入地下',
    'MI-0006': '头盔架',
    'MI-0007': '寻找掩护！',
    'MI-0008': '勤奋工作',
    'MI-0009': '镐子还是铲子？',
    'MI-0010': '太小了',
    'MI-0011': '积极的工人',
    'MI-0012': '工伤事故',
    'MI-0013': '临时存储',
    'MI-0014': '装满的箱子',
    'MI-0015': '返回地表',
    'MI-0016': '提取',
    'MI-0017': '运输',
    'MI-0018': '质量控制',
    'MI-0019': '回收工厂',
    'MI-0020': '液压机',
    'MI-0021': '精炼实验',
    'MI-0022': '机器人组装',
    'MI-0023': '卡住的镐子',
    'MI-0024': '矿井入口',
    'MI-0025': '引爆岩堆',
    'MI-0026': '矿井',
    'MI-0027': '地表岩石',
    'MI-0028': '惊扰蝙蝠',
    'MI-0029': '令人毛骨悚然',
    'MI-0030': '稀有发现',
    'MI-0031': '地下湖',
    'MI-0032': '易燃液体',
    'MI-0033': '地下墓地',
    'MI-0034': '潜伏的蜘蛛',
    'MI-0035': '无路可逃',
    'MI-0036': '地震',
    'MI-0037': '有毒气体',
    'MI-0038': '水晶尖刺',

    'VI-0001': '巨大岩石',
    'VI-0002': '隐藏宝石',
    'VI-0003': '钟乳石洞',
    'VI-0004': '分岔路',
    'VI-0005': '洞穴花卉',
    'VI-0006': '户外露营',
    'VI-0007': '游乐场',
    'VI-0008': '宁静区域',
    'VI-0009': '愤怒的邻居',
    'VI-0010': '带花园的房子',
    'VI-0011': '建造家园',
    'VI-0012': '露营之旅',
    'VI-0013': '客厅',
    'VI-0014': '狗屋',
    'VI-0015': '屋顶花园',
    'VI-0016': '百年古树',
    'VI-0017': '盗伐',
    'VI-0018': '社区花园',
    'VI-0019': '再造林',
    'VI-0020': '森林砍伐',
    'VI-0021': '木材运输车',
    'VI-0022': '研究实验室',
    'VI-0023': '实验',
    'VI-0024': '疾病分析',
    'VI-0025': '成型钢条',
    'VI-0026': '钉子工厂',
    'VI-0027': '古老图书馆',
    'VI-0028': '机械钟表',
    'VI-0029': '烹饪机器人',
    'VI-0030': '远程车库',
    'VI-0031': '发电机',
    'VI-0032': '太阳能电池板',
    'VI-0033': '自动驾驶汽车',
    'VI-0034': '消防员',
    'VI-0035': '警察局',
    'VI-0036': '照亮道路',
    'VI-0037': '救助小狗',
    'VI-0038': '救护车',
    'VI-0039': '救生员',

    'HO-0001': '潜伏的蛇',
    'HO-0002': '深坑',
    'HO-0003': '喷发的火山',
    'HO-0004': '迷路',
    'HO-0005': '永久冻结',
    'HO-0006': '岩浆室',
    'HO-0007': '背包检查',
    'HO-0008': '筑墙',
    'HO-0009': '监控摄像头',
    'HO-0010': '蘑菇指南',
    'HO-0011': '电围栏',
    'HO-0012': '超级炸弹',
    'HO-0013': '火箭发射器',
    'HO-0014': '飞剑',
    'HO-0015': '毒箭',
    'HO-0016': '制导导弹',
    'HO-0017': '投斧手',
    'HO-0018': '强力笔',
    'HO-0019': '投石机',
    'HO-0020': '枪刃',
    'HO-0021': '阳光射线',
    'HO-0022': '锯片发射器',
    'HO-0023': '超强腐蚀剂',
    'HO-0024': '自然掩护',
    'HO-0025': '森林冥想',
    'HO-0026': '金属探测器',
    'HO-0027': '弹射物护盾',
    'HO-0028': '力场',
    'HO-0029': '雷达',
    'HO-0030': '间谍',
    'HO-0031': '禁止腐化',
    'HO-0032': '液体过滤器',
    'HO-0033': '洗衣机',
    'HO-0034': '火烧净化',
    'HO-0035': '净化光束',
    'HO-0036': '抑制腐化',
    'HO-0037': '扔进垃圾桶！',
    'HO-0038': '奇异仪式',
    'HO-0039': '吸尘器',
    'HO-0040': '科学力量',
    'HO-0041': '微波加热即可',

    'FA-0001': '采摘苹果',
    'FA-0002': '南瓜比赛',
    'FA-0003': '花店',
    'FA-0004': '办公室植物',
    'FA-0005': '稻草人',
    'FA-0006': '人工降雨',
    'FA-0007': '补给列车',
    'FA-0008': '食品运输',
    'FA-0009': '温暖的温室',
    'FA-0010': '水果冰沙',
    'FA-0011': '面包店特卖',
    'FA-0012': '冰淇淋车',
    'FA-0013': '快餐订单',
    'FA-0014': '盛宴',
    'FA-0015': '糖果王国',
    'FA-0016': '下午茶时间',
    'FA-0017': '酿造葡萄酒',
    'FA-0018': '饼干与咖啡',
    'FA-0019': '橙色蔬菜',
    'FA-0020': '辛辣果香红',
    'FA-0021': '雏菊黄',
    'FA-0022': '植物绿',
    'FA-0023': '蓝莓丛',
    'FA-0024': '紫色蘑菇',
    'FA-0025': '昆虫粉末',
    'FA-0026': '新鲜青柠',
    'FA-0027': '蝴蝶翅膀',

    'GA-0001': '瓢虫',
    'GA-0002': '彩色羽毛',
    'GA-0003': '制作柠檬水',
    'GA-0004': '藻类',
    'GA-0005': '艺术博物馆',
    'GA-0006': '铅笔画',
    'GA-0007': '钢笔收藏',
    'GA-0008': '喷漆',
    'GA-0009': '调色板',
    'GA-0010': '壁画',
    'GA-0011': '艺术家签名',
    'GA-0012': '调配颜料',
    'GA-0013': '现代艺术拍卖',
    'GA-0014': '肖像画',
    'GA-0015': '回收箱',
    'GA-0016': '披萨外送',
    'GA-0017': '包裹送达',
    'GA-0018': '校车',
    'GA-0019': '鼓制造厂',
    'GA-0020': '货轮',
    'GA-0021': '搬家公司',
    'GA-0022': '无人机配送',
    'GA-0023': '拖车',

    'GE-0001': '红宝石铁路',
    'GE-0002': '祖母绿矿',
    'GE-0003': '沉没的宝藏',
    'GE-0004': '奢华腕表',
    'GE-0005': '危险的三角形',
    'GE-0006': '金刚石工具',
    'GE-0007': '安防措施',

    'EV-0001': '公平',
    'EV-0002': '建筑竞赛',
    'EV-0003': '炙烤',
    'EV-0004': '生日聚会',
    'EV-0005': '旧货出售',
    'EV-0006': '加油站',
    'EV-0007': '本地商户',
    'EV-0008': '电视宾果游戏',
    'EV-0009': '赌场',
    'EV-0010': '???',
    'EV-0011': '银行保险箱',
    'EV-0012': '利润！',
    'EV-0013': '信用卡',
    'EV-0014': '沙漠',
    'EV-0015': '滑翔伞',
    'EV-0016': '丛林之谜',
    'EV-0017': '搁浅的乌龟',
    'EV-0018': '花卉育种',
    'EV-0019': '植物样本',
    'EV-0020': '鱼叉捕鱼',
    'EV-0021': '蜗牛赛跑',
    'EV-0022': '孤岛',
    'EV-0023': '夏日之歌',
    'EV-0024': '舒适的沙发',
    'EV-0025': '讨厌的山',
    'EV-0026': '夜晚的城市',
    'EV-0027': '热苹果汁',
    'EV-0028': '神秘的汤',
    'EV-0029': '秘泉',
    'EV-0030': '做雪人',
    'EV-0031': '冬季运动',
    'EV-0032': '城堡灯',
    'EV-0033': '灯泡店',

    'XD-1337': '测试卡'
  },
  collection: {
    minersAndEquipment: '矿工和装备',
    scrapLogistics: '废料物流',
    caveLocations: '洞穴位置',
    dangersInTheDark: '黑暗中的危险',
    neighborhood: '邻里',
    plantsInTheCity: '城市里的植物',
    industrialRevolution: '工业革命',
    maintainingSafety: '维护安全',
    dangerousWeapons: '危险武器',
    supplyAndSupport: '供应与支持',
    againstTheCorruption: '反对腐败',
    feedingTheWorld: '喂养世界',
    organicDyes: '有机染料',
    artDisplay: '艺术展示',
    deliveryService: '送货服务',
    preciousJewelry: '贵重珠宝',
    weekendTrip: '周末旅行',
    tropicalParadise: '热带天堂',
    coldTimes: '寒冷时期',
  },
  pack: {
    intoDarkness: '进入黑暗',
    drillsAndDepths: '钻孔和深度',
    hotStuff: '热门内容',
    dangerZone: '危险区',
    meetingNewPeople: '结识新朋友',
    darkCult: '黑暗教派',
    technologicalAdvancement: '科技进步',
    rookieOnTheBattlefield: '战场上的菜鸟',
    spiritualSuccess: '精神上的成功',
    oldMemories: '旧的记忆',
    taintedWorld: '被污染的世界',
    bountifulHarvest: '丰收',
    juicyYields: '多汁的产量',
    insectWorld: '昆虫世界',
    beesAndFlowers: '蜜蜂和鲜花',
    newArtist: '新艺术家',
    inspiringCreations: '鼓舞人心的创作',
    goodDeal: '好交易',
    connectedLine: '连接线',
    feelingLucky: '感觉很幸运',
    investorsDream: '投资者梦想',
    greenThumb: '园艺高手',
    fishingForFun: '钓鱼为乐',
    charmingShip: '迷人的船',
    midnightAnomaly: '午夜异常',
    icyWonderland: '冰雪仙境',
    sparksOfJoy: '欢乐的火花',
  }
};